import Vue from 'vue';
import VueI18n from '../i18n/i18n';
import systemServerErrorHelper from './system-server-error-helper';

class MessagesNotifyHelper {

    createdRecordNotify() {
        this.successNotify(VueI18n.t('GENERAL').Create, VueI18n.t('MESSAGES').Messages_Created);
    }

    updatedRecordNotify() {
        this.successNotify(VueI18n.t('GENERAL').Update, VueI18n.t('MESSAGES').Messages_Updated);
    }

    deletedRecordNotify() {
        this.successNotify(VueI18n.t('GENERAL').Delete, VueI18n.t('MESSAGES').Messages_Deleted);
    }

    genericErrorNotify() {
        this.errorNotify(VueI18n.t('GENERAL').Error, VueI18n.t('MESSAGES').Messages_Generic_Error);
    }

    handleError(error) {
        if (error.errorType == 'demo-siga') {
            return;
        }
        if (error.errorType == 'system-server') {
            const text = systemServerErrorHelper.getTranslateErrorText(error.code);
            if (text) {
                this.errorNotify(VueI18n.t('DIALOG_MESSAGES').Title, text);
                return;
            }
            this.genericErrorNotify();
            return;
        }
        if (error.erros) {
            this.errorNotify(error.erros[0].field, error.erros[0].message);
            return;
        }
        if (error.message) {
            if (error.message.indexOf('Access Denied') >= 0) {
                this.warningNotify('Acesso', 'Acesso negado');
                return;
            }
            if (Array.isArray(error.message)) {
                error.message.forEach(item => {
                    this.errorNotify('Aviso', item);
                });
            } else {
                this.errorNotify('Aviso', error.message);
            }
            return;
        }
        
        this.errorNotify('Aviso', 'Erro ao executar a operação');
    }

    errorNotify(title, text) {
        Vue.prototype.$vs.notify({
            title: title,
            text: text,
            color: "danger"
        });
    }

    successNotify(title, text) {
        Vue.prototype.$vs.notify({
            title: title,
            text: text,
            color: "success"
        });
    }

    warningNotify(title, text) {
        Vue.prototype.$vs.notify({
            title: title,
            text: text,
            color: "warning"
        });
    }

    messageNotify(title, text) {
        Vue.prototype.$vs.notify({
            title: title,
            text: text,
            color: "dark"
        });
    }

    addPlaylistNotify(item) {
        let text = '';
        if (item.youtube) {
            text = VueI18n.t("PLAYLIST").Youtube_Add_Playlist_Text;
        } else if (item.audio_filename) {
            text = VueI18n.t("PLAYLIST").Audio_Add_Playlist_Text;
        } else {
            text = VueI18n.t("PLAYLIST").Item_Add_Playlist_Text;
        }
        
        Vue.prototype.$vs.notify({
            title: 'Playlist',
            text: text,
            color: "dark"
        });
    }
}

export default new MessagesNotifyHelper();